import React, { useState, useEffect } from "react";
import './index.scss';

const ScrollNumber = ({ data = '' }) => {
  const array = (data + '').split('');
  return <div className="numbers-container">
    {
      array && array.map((item, index) => {
        if (typeof item * 1 == 'number') {
          return <div key={'label' + index} className="numbers-box numberFont">
            <span className={`numbers-scroll numbers-scroll${item}`}>
              <label>0</label>
              <label>1</label>
              <label>2</label>
              <label>3</label>
              <label>4</label>
              <label>5</label>
              <label>6</label>
              <label>7</label>
              <label>8</label>
              <label>9</label>
              <label>0</label>
            </span>
          </div>

        } else {
          return <div key={'lab' + index} className="numbers-box numberFont">
            <div>{item}</div>
          </div>
        }
      })
    }

  </div>
}

export default ScrollNumber;
